export enum EAction {
    Initialization = '@lk/vas/initialization',
    SetLoading = '@lk/vas/loading/set',
    SetLoaded = '@lk/vas/loaded/set',
    ToggleShowAllCategoryItems = '@lk/vas/category/items/showAll/toggle',
    SetSpeedBonuses = '@lk/vas/items/SpeedBonuses/set',
    SetCategory = '@lk/vas/category/set',
}
